import React, { useEffect, useMemo, useRef } from 'react'
import { Button, Form, Input, message, Radio, RadioChangeEvent, Select, Spin } from 'antd'
import { SGeneralForms, SSegmentedTabs } from 'shj-components'
import {
  getPriceItemList,
  getProductEnums,
  getSpecialCodesList,
  priceItemSave,
  priceItemUpdateById,
} from '@/services/product.ts'
import { useSetState } from 'ahooks'
import RulesModal from '@/pages/baseProduct/components/RuleModal/RulesModal.tsx'
import { isEmpty } from 'lodash-es'
import { replaceRule, trimStr } from '@/utils/data.ts'

const AddOrEdit = props => {
  const { editRef } = props
  const ref = useRef()
  const [state, setState] = useSetState<any>({
    priceMathTypeEnum: [],
    chooseTypeKey: '',
    hasParent: null,
    specialCodeList: [],
    otherConfigType: '',
    priceOtherConfigTypeEnum: [],
    spinning: false,
  })

  const [ruleModal, setRuleModal] = useSetState({
    open: false,
    mode: 'modal',
    value: '',
  })

  const tooltipObj = {
    CUSTOM_FORMULA: '',
    CUSTOMER_SUM: '指当前报价中所有已选产品客户价合计',
    GIVEN_CUSTOMER_SUM:
      '指当前报价中指定项已选产品客户价合计，指定项在产品关联费用项后进行勾选设置',
    CHILD_SUM: '等于当前子费用项的费用合计',
    CREATOR_ENTRY: '指价格由报价人自行输入，满足下面最大值最小值要求，最大值最小值不设置则代表不限',
    REGULAR: '',
    IMPORT_DATA:
      '保存费用后在该费用行上，点击导入费用，进行费用导入。主要用于与套内面积、卫生间个数相关的费用场景。',
  }
  const showMathTypeList = [
    'OTHER',
    'ADDITIONAL',
    'ADDITIONAL_DISCOUNT',
    'PROJECT_TOTAL_DISCOUNT',
    'LOAN_INTEREST',
    'SOFT_DECORATION_ACTUAL_AMOUNT',
    'PACKAGE_ITEM_TOTAL_SALES_PRICE',
  ]

  const onFormRef = () => {
    const { onFormRef } = ref.current || {}
    return onFormRef?.()
  }

  useEffect(() => {
    onFormRef()?.resetFields()
    setState({ chooseTypeKey: '' })
    setRuleModal({ value: '' })
    if (!isEmpty(props.record)) {
      console.log(props.record)

      onFormRef()?.setFieldsValue({
        ...props.record,
        parentId: props.record.parentId !== '0' ? props.record.parentId : '',
      })
      setRuleModal({ value: props.record.formulaRule })
    }
    if (props.record.parentId && props.record.parentId !== '0') setState({ hasParent: true })
    if (!props.record.id) {
      onFormRef()?.setFieldsValue({
        mathType: state.priceMathTypeEnum[0]?.value,
        otherConfigType: state.priceOtherConfigTypeEnum[0]?.value,
      })
      setState({
        chooseTypeKey: state.priceMathTypeEnum[0]?.value,
        otherConfigType: state.priceOtherConfigTypeEnum[0]?.value,
      })
    }
  }, [props.record, state.priceMathTypeEnum])

  const getOptions = async () => {
    setState({ spinning: true })
    try {
      const priceMathTypeEnum = await getProductEnums(
        'com.shj.saas.plus.product.enums.PriceMathTypeEnum'
      )
      const priceOtherConfigTypeEnum = await getProductEnums(
        'com.shj.saas.plus.product.enums.PriceOtherConfigTypeEnum'
      )
      const parentList = await getPriceItemList({
        costType: props.type,
        parentId: '0',
        enabled: true,
      })
      let specialCodeList: any = await getSpecialCodesList({
        data: {
          enabled: true,
        },
      })
      const FeeImportTypeEnum = await getProductEnums(
        'com.shj.saas.plus.product.enums.FeeImportTypeEnum'
      )
      specialCodeList = specialCodeList.map(item => ({ label: item.showName, value: item.code }))
      setState({
        priceMathTypeEnum: priceMathTypeEnum.map(item => ({
          label: item.description,
          value: item.key,
        })),
        priceOtherConfigTypeEnum: priceOtherConfigTypeEnum.map(item => ({
          label: item.description,
          value: item.key,
        })),
        FeeImportTypeEnum: FeeImportTypeEnum.map(item => ({
          label: item.description,
          value: item.key,
        })),
        specialCodeList: specialCodeList,
        spinning: false,
      })
      return Promise.resolve({
        parentList,
        specialCodeList,
        priceOtherConfigTypeEnum,
        FeeImportTypeEnum,
      })
    } catch (error) {
      setState({ spinning: false })
      return Promise.reject(error)
    }
  }

  const onFinish = () => {
    console.log(state)
    if (state.chooseTypeKey === 'CUSTOM_FORMULA' && !ruleModal.value)
      return message.error('自定义公式，规则不能为空')
    onFormRef()
      ?.validateFields()
      .then(values => {
        console.log(values)
        props.setLoading?.(true)
        const apiUrl = values.id ? priceItemUpdateById : priceItemSave
        apiUrl({
          data: {
            ...values,
            parentId: values.parentId || 0,
            costType: props.type,
            formulaRule: ruleModal.value,
          },
        })
          .then((res: any) => {
            message.success(res.message || '操作成功')
            props.onCancel?.()
            props.fn?.()
          })
          .finally(() => props.setLoading(false))
      })
  }

  const setComparedSubFlag = () => {
    onFormRef().setFieldValue('comparedSubFlag', false)
  }
  const calcRuleShowRender = () => {
    // if (props.type === 'COST_OTHERS') {
    if (showMathTypeList.includes(onFormRef()?.getFieldValue('otherConfigType'))) {
      return [
        {
          name: 'mathType',
          label: '计算方式',
          required: true,
          rules: [{ required: true, message: '计算方式不能为空' }],
          spanCol: 24,
          children: (
            <Radio.Group
              className={'radioGroupBox'}
              disabled={props.record.id || state.otherConfigType === 'LOAN_INTEREST'}
              onChange={({ target: { value } }) => {
                changeMathType(value)
              }}
              options={
                state.hasParent
                  ? state.priceMathTypeEnum.filter(item => item.value !== 'CHILD_SUM')
                  : state.priceMathTypeEnum
              }
            />
          ),
        },
        {
          spanCol: 24,
          isDeps: true,
          deps: form => form.getFieldValue('mathType') === 'CUSTOM_FORMULA',
          children: (
            <div style={{ marginTop: -8 }}>
              <Button onClick={() => setRuleModal({ open: true })}>编辑公式</Button>
              {ruleModal?.value && (
                <Input.TextArea
                  autoSize={{ minRows: 1, maxRows: 4 }}
                  disabled
                  style={{ marginTop: 6 }}
                  value={replaceRule(ruleModal.value)}
                />
              )}
            </div>
          ),
        },
        {
          spanCol: 24,
          isDeps: true,
          deps: () => tooltipObj[state.chooseTypeKey],
          children: () => {
            return (
              <div
                style={{
                  marginTop: '-20px',
                  marginLeft: 5,
                  color: '#a9a9a9',
                }}
              >
                {tooltipObj[state.chooseTypeKey]}
              </div>
            )
          },
        },
      ]
    } else {
      return []
    }
  }

  const changeMathType = value => {
    // 一些特殊处理
    if (value === 'CREATOR_ENTRY') {
      setComparedSubFlag()
    }
    if (value === 'IMPORT_DATA') {
      let feeImportTypeEnum = onFormRef().getFieldValue('feeImportTypeEnum')
      feeImportTypeEnum = feeImportTypeEnum ? feeImportTypeEnum : 'FIXED_PRICE'
      onFormRef().setFieldValue('feeImportTypeEnum', feeImportTypeEnum)
    }
    setState({ chooseTypeKey: value })
  }
  if (editRef) editRef.onFinish = onFinish

  return (
    <>
      <Spin spinning={state.spinning}>
        <SGeneralForms
          ref={ref}
          httpOptionsFn={getOptions}
          layout={'vertical'}
          initialValues={{ showFlag: true, editFlag: false, comparedSubFlag: false }}
          configs={[
            {
              formItem: [
                { label: 'id', name: 'id', hidden: true },
                {
                  label: '上级费用项',
                  name: 'parentId',
                  spanCol: 24,
                  type: 'select',
                  data: 'parentList',
                  comConfig: {
                    fieldNames: { label: 'itemName', value: 'id' },
                    disabled: props.record?.children || props.record?.initFlag,
                    onChange: e => {
                      setState({ hasParent: e })
                      if (e) {
                        // onFormRef().setFieldValue('mathType', state.priceMathTypeEnum[0]?.value)
                        // setState({ chooseTypeKey: state.priceMathTypeEnum[0]?.value })
                      }
                    },
                  },
                },
                {
                  spanCol: 24,
                  customRender: (
                    <div
                      style={{ marginTop: -10, marginBottom: 10, marginLeft: 5, color: '#a9a9a9' }}
                    >
                      不选则添加在根目录下
                    </div>
                  ),
                },
                {
                  spanCol: 24,
                  label: '费用项名称',
                  name: 'itemName',
                  required: true,
                  rules: [{ required: true, message: '费用项名称不能为空' }],
                  style: { marginTop: -15 },
                  comConfig: {
                    disabled: props.record.initFlag,
                    showCount: true,
                    maxLength: 15,
                    onChange: e => onFormRef()?.setFieldValue('itemName', trimStr(e.target.value)),
                  },
                },
                {
                  name: 'specialCode',
                  label: '特项代码',
                  spanCol: 24,
                  children: (
                    <Select
                      allowClear
                      placeholder="请选择"
                      options={state.specialCodeList}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={e => onFormRef()?.setFieldValue('specialCode', e)}
                    />
                  ),
                },
                {
                  name: 'otherConfigType',
                  label: '类型',
                  required: true,
                  rules: [{ required: true, message: '类型不能为空' }],
                  spanCol: 24,
                  children: (
                    <Radio.Group
                      className={'radioGroupBox'}
                      disabled={props.record.id}
                      onChange={({ target: { value } }: RadioChangeEvent) => {
                        setState({ chooseTypeKey: '' })
                        onFormRef().setFieldValue('mathType', '')
                        if (value === 'LOAN_INTEREST') {
                          setState({ chooseTypeKey: 'CREATOR_ENTRY' })
                          onFormRef().setFieldValue('mathType', 'CREATOR_ENTRY')
                        } else if(showMathTypeList.includes(value)){
                          onFormRef().setFieldValue('mathType', state.priceMathTypeEnum[0]?.value)
                        }
                        setState({ otherConfigType: value })
                      }}
                      options={state.priceOtherConfigTypeEnum}
                    />
                  ),
                },
                ...calcRuleShowRender(),
                {
                  label: '加乘比例',
                  name: 'additiveRatio',
                  spanCol: 24,
                  isDeps: true,
                  tooltip:
                    '加乘比例指计算结果值是否再乘以特定比例，不输入表示不加乘，与输入1结果相同',
                  deps: form =>
                    ['GIVEN_CUSTOMER_SUM', 'CHILD_SUM'].includes(form.getFieldValue('mathType')),
                  type: 'inputNumber',
                  comConfig: {
                    min: 0,
                  },
                },
                {
                  label: '金额',
                  spanCol: 24,
                  name: 'price',
                  required: true,
                  rules: [{ required: true, message: '金额不能为空' }],
                  isDeps: true,
                  deps: form => form.getFieldValue('mathType') === 'REGULAR',
                  type: 'inputNumber',
                  comConfig: {
                    min: 0,
                    precision: 2,
                  },
                },
                {
                  name: 'feeImportTypeEnum',
                  label: '导入类型',
                  required: true,
                  isDeps: true,
                  deps: form => form.getFieldValue('mathType') === 'IMPORT_DATA',
                  rules: [{ required: true, message: '导入类型不能为空' }],
                  spanCol: 24,
                  children: (
                    <Radio.Group
                      className={'radioGroupBox'}
                      disabled={props.record.id}
                      options={state.FeeImportTypeEnum}
                    />
                  ),
                },
                {
                  label: '是否比差',
                  name: 'comparedSubFlag',
                  spanCol: 24,
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                    disabled: onFormRef()?.getFieldValue('mathType') === 'CREATOR_ENTRY',
                  },
                },
                {
                  spanCol: 24,
                  children: (
                    <div
                      style={{ marginTop: -10, marginBottom: 10, marginLeft: 5, color: '#a9a9a9' }}
                    >
                      比差代表报价时：当前费用项值=计算方式算出价格-该费用项已确认报价累计值
                    </div>
                  ),
                },
                {
                  label: '是否显示',
                  name: 'showFlag',
                  spanCol: 24,
                  isDeps: true,
                  deps: form =>
                    form.getFieldValue('parentId') &&
                    form.getFieldValue('otherConfigType') !== 'LOAN_INTEREST' &&
                    form.getFieldValue('mathType') !== 'CREATOR_ENTRY',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
                {
                  label: '是否可编辑',
                  name: 'editFlag',
                  spanCol: 24,
                  isDeps: true,
                  deps: form =>
                    form.getFieldValue('otherConfigType') !== 'LOAN_INTEREST' &&
                    form.getFieldValue('showFlag') !== false &&
                    form.getFieldValue('mathType') !== 'CREATOR_ENTRY',
                  type: 'switch',
                  comConfig: {
                    checkedChildren: '是',
                    unCheckedChildren: '否',
                  },
                },
              ],
            },
          ]}
        />
        <RulesModal
          modalProps={{ ...ruleModal }}
          query={{ excludeId: props.record.id }}
          onCancel={() => setRuleModal({ open: false })}
          onOk={(value: string) => setRuleModal({ value })}
        />
      </Spin>
    </>
  )
}

export default AddOrEdit
